import { useState, useEffect } from "react";
import Modal from "../ui/Modal";
import { useContactForm } from "../../hooks/useContactForm";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export default function ConsultationModal({ isOpen, onClose }: Props) {
  const { submit, loading, error, success, reset } = useContactForm();

  const [form, setForm] = useState({
    name: "",
    email: "",
    company: "",
    service: "",
    message: ""
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    setForm(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const submitted = await submit({
      subject: `Consultation Request - ${form.service}`,
      message: form.message,
      htmlMessage: `<p>${form.message}</p>`,
      name: form.name,
      company: form.company,
      email: form.email
    });

    if (submitted) {
      setTimeout(() => {
        reset();
        onClose();
      }, 1500);
    }
  };

  // Optional: reset form when modal closes
  useEffect(() => {
  if (!isOpen) {
    setForm({
      name: "",
      email: "",
      company: "",
      service: "",
      message: ""
    });

    reset();
    }
   }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Request Consultation">
      <p className="mb-4 text-sm text-gray-600">
        Schedule a consultation with our experts to discuss your goals and
        technical requirements.
      </p>

      {success && (
        <div className="mb-3 rounded-md bg-green-50 p-2 text-sm text-green-700">
           Request sent successfully!
        </div>
      )}

      {error && (
        <div className="mb-3 rounded-md bg-red-50 p-2 text-sm text-red-600">
          {error}
        </div>
      )}

      <form className="space-y-4" onSubmit={handleSubmit}>
        <input
          name="name"
          placeholder="Full Name"
          value={form.name}
          onChange={handleChange}
          required
          className="w-full rounded-md border px-3 py-2 text-sm"
        />

        <input
          name="email"
          type="email"
          placeholder="Business Email"
          value={form.email}
          onChange={handleChange}
          required
          className="w-full rounded-md border px-3 py-2 text-sm"
        />

        <input
          name="company"
          placeholder="Company Name"
          value={form.company}
          onChange={handleChange}
          className="w-full rounded-md border px-3 py-2 text-sm"
        />

        <select
          name="service"
          value={form.service}
          onChange={handleChange}
          required
          className="w-full rounded-md border px-3 py-2 text-sm"
        >
          <option value="">Service of Interest</option>
          <option>BPO Services</option>
          <option>Web Development</option>
          <option>Address Intelligence</option>
        </select>

        <textarea
          name="message"
          placeholder="Briefly describe your needs"
          rows={3}
          value={form.message}
          onChange={handleChange}
          className="w-full rounded-md border px-3 py-2 text-sm"
        />

        <button
          type="submit"
          disabled={loading}
          className="w-full rounded-md bg-blue-600 py-2 text-sm font-semibold text-white hover:bg-blue-700 disabled:opacity-50"
        >
          {loading ? "Sending..." : "Request Consultation"}
        </button>
      </form>
    </Modal>
  );
}